<template>
  <div class="block-container seo-footer">
    <div class="container">
      <nav class="footer-nav">
        <div class="footer-nav__block">
          <div class="footer-nav__menu">
            <span class="h3">CARRETERA</span>
            <ul>
              <li>
                <NuxtLink
                  to="/cascos-para-moto"
                  class="mtc-link"
                >
                  Cascos
                </NuxtLink>
              </li>
              <li>
                <NuxtLink
                  to="/chaquetas-para-moto"
                  class="mtc-link"
                >
                  Chaquetas
                </NuxtLink>
              </li>
              <li>
                <NuxtLink
                  to="/botas-para-moto"
                  class="mtc-link"
                >
                  Botas
                </NuxtLink>
              </li>
              <li>
                <NuxtLink
                  to="/guantes-para-moto"
                  class="mtc-link"
                >
                  Guantes
                </NuxtLink>
              </li>
              <li>
                <NuxtLink
                  to="/pantalones-para-moto"
                  class="mtc-link"
                >
                  Pantalones
                </NuxtLink>
              </li>
              <li>
                <NuxtLink
                  to="/trajes-para-moto"
                  class="mtc-link"
                >
                  Trajes / monos
                </NuxtLink>
              </li>
              <li>
                <NuxtLink
                  to="/accesorios-para-cascos"
                  class="mtc-link"
                >
                  Accesorios casco
                </NuxtLink>
              </li>
              <li>
                <NuxtLink
                  to="/intercomunicadores-gps-para-moto"
                  class="mtc-link"
                >
                  Electrónica
                </NuxtLink>
              </li>
              <li>
                <NuxtLink
                  to="/termicos-para-moto"
                  class="mtc-link"
                >
                  Térmicos
                </NuxtLink>
              </li>
              <li>
                <NuxtLink
                  to="/ropa-lluvia"
                  class="mtc-link"
                >
                  Impermeables
                </NuxtLink>
              </li>
              <li>
                <NuxtLink
                  to="/protecciones-para-motociclistas"
                  class="mtc-link"
                >
                  Protecciones
                </NuxtLink>
              </li>
              <li>
                <NuxtLink
                  to="/bolsos-para-moto"
                  class="mtc-link"
                >
                  Bolsas
                </NuxtLink>
              </li>
            </ul>
          </div>
        </div>
        <div class="footer-nav__block">
          <div class="footer-nav__menu">
            <span class="h3">MOTOCROSS</span>
            <ul>
              <li>
                <NuxtLink
                  to="/cascos-mx-enduro-para-moto"
                  class="mtc-link"
                >
                  Cascos
                </NuxtLink>
              </li>
              <li>
                <NuxtLink
                  to="/botas-mx-enduro-para-moto"
                  class="mtc-link"
                >
                  Botas
                </NuxtLink>
              </li>
              <li>
                <NuxtLink
                  to="/pantalones-motocross"
                  class="mtc-link"
                >
                  Pantalones
                </NuxtLink>
              </li>
              <li>
                <NuxtLink
                  to="/antiparras-para-moto"
                  class="mtc-link"
                >
                  Antiparras
                </NuxtLink>
              </li>
              <li>
                <NuxtLink
                  to="/jerseys-para-moto"
                  class="mtc-link"
                >
                  Jerseys
                </NuxtLink>
              </li>
              <li>
                <NuxtLink
                  to="/guantes-offroad-para-moto"
                  class="mtc-link"
                >
                  Guantes
                </NuxtLink>
              </li>
              <li>
                <NuxtLink
                  to="/chaquetas-mx-para-moto"
                  class="mtc-link"
                >
                  Chaquetas
                </NuxtLink>
              </li>
              <li>
                <NuxtLink
                  to="/protecciones-mx-para-moto"
                  class="mtc-link"
                >
                  Protecciones
                </NuxtLink>
              </li>
              <li>
                <NuxtLink
                  to="/mochilas-y-bolsos-para-moto"
                  class="mtc-link"
                >
                  Bolsas
                </NuxtLink>
              </li>
              <li>
                <NuxtLink
                  to="/ropa-lluvia"
                  class="mtc-link"
                >
                  Impermeables
                </NuxtLink>
              </li>
            </ul>
          </div>
        </div>
        <div class="footer-nav__block">
          <div class="footer-nav__menu">
            <span class="h3">ACCESORIOS</span>
            <ul>
              <li>
                <NuxtLink
                  to="/maletas-para-motos"
                  class="mtc-link"
                >
                  Maletas
                </NuxtLink>
              </li>
              <li>
                <NuxtLink
                  to="/seguridad"
                  class="mtc-link"
                >
                  Antirrobos
                </NuxtLink>
              </li>
              <li>
                <NuxtLink
                  to="/intercomunicadores-gps-para-moto"
                  class="mtc-link"
                >
                  Electrónica
                </NuxtLink>
              </li>
              <li>
                <NuxtLink
                  to="/bolsos-para-moto"
                  class="mtc-link"
                >
                  Bolsas
                </NuxtLink>
              </li>
              <li>
                <NuxtLink
                  to="/lubricantes-y-fluidos-para-motos"
                  class="mtc-link"
                >
                  Aceites y sprays
                </NuxtLink>
              </li>
              <li>
                <NuxtLink
                  to="/caballetes"
                  class="mtc-link"
                >
                  Caballetes
                </NuxtLink>
              </li>
              <li>
                <NuxtLink
                  to="/carpas-para-moto"
                  class="mtc-link"
                >
                  Fundas
                </NuxtLink>
              </li>
              <li>
                <NuxtLink
                  to="/anclajes"
                  class="mtc-link"
                >
                  Kits de fijación
                </NuxtLink>
              </li>
              <li>
                <NuxtLink
                  to="/protector-de-punos"
                  class="mtc-link"
                >
                  Paramanos
                </NuxtLink>
              </li>
              <li>
                <NuxtLink
                  to="/accesorios-de-top-case"
                  class="mtc-link"
                >
                  Respaldos
                </NuxtLink>
              </li>
            </ul>
          </div>
        </div>
        <div class="footer-nav__block">
          <div class="footer-nav__menu">
            <span class="h3">Ropa casual</span>
            <ul>
              <li>
                <NuxtLink
                  to="/zapatillas-para-moto"
                  class="mtc-link"
                >
                  Zapatillas
                </NuxtLink>
              </li>
              <li>
                <NuxtLink
                  to="/chaquetas-casual"
                  class="mtc-link"
                >
                  Chaquetas
                </NuxtLink>
              </li>
              <li>
                <NuxtLink
                  to="/poleras-para-moto"
                  class="mtc-link"
                >
                  Camisetas
                </NuxtLink>
              </li>
              <li>
                <NuxtLink
                  to="/llaveros"
                  class="mtc-link"
                >
                  Llaveros
                </NuxtLink>
              </li>
              <li>
                <NuxtLink
                  to="/mochilas"
                  class="mtc-link"
                >
                  Bolsas
                </NuxtLink>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </div>
  </div>

  <footer class="footer">
    <div class="container">
      <div class="row">
        <div class="col s12 12 footer-container">
          <aside class="footer-description">
            <div class="motomundi-logo">
              <NuxtLink
                to="/"
                class="motomundi-logo-link mtc-link"
              >
                <span>
                  <img
                    src="/logo-motomundi.png"
                    alt="Motomundi"
                    width="190"
                    class="cdn-img"
                  >
                </span>
              </NuxtLink>
            </div>
            <p>
              En la nueva web Motomundi.cl encontrarás el mayor stock en
              venta online de accesorios y equipación para moto. Nuestra máxima garantía es la
              confianza que han depositado en nosotros las mejores marcas de equipación de
              carretera y off-road.
            </p>
            <span class="h3">Redes Sociales</span>
            <nav>
              <ul>
                <li>
                  <NuxtLink
                    to="/blog"
                    target="_blank"
                    class="sm-blog"
                  >
                    <svg
                      width="12"
                      height="12"
                      xmlns="http://www.w3.org/2000/svg"
                      class="icon sprite-icons"
                    >
                      <title>Blog</title>
                      <use
                        href="/content/svg/motomundi.svg?v=1.4#i-sm-blog"
                        xlink:href="/content/svg/motomundi.svg?v=1.4#i-sm-blog"
                      />
                    </svg>
                  </NuxtLink>
                </li>
                <li>
                  <NuxtLink
                    to="https://facebook.com/motomundi"
                    target="_blank"
                    rel="noopener"
                    class="sm-fb"
                  >
                    <svg
                      width="9"
                      height="15"
                      xmlns="http://www.w3.org/2000/svg"
                      class="icon sprite-icons"
                    >
                      <title>Facebook</title>
                      <use
                        href="/content/svg/motomundi.svg?v=1.4#i-sm-fb"
                        xlink:href="/content/svg/motomundi.svg?v=1.4#i-sm-fb"
                      />
                    </svg>
                  </NuxtLink>
                </li>
                <li>
                  <NuxtLink
                    to="https://twitter.com/motomundi?"
                    target="_blank"
                    rel="noopener"
                    class="sm-tw"
                  >
                    <svg
                      width="16"
                      height="14"
                      xmlns="http://www.w3.org/2000/svg"
                      class="icon sprite-icons"
                    >
                      <title>Twitter</title>
                      <use
                        href="/content/svg/motomundi.svg?v=1.4#i-sm-twitter"
                        xlink:href="/content/svg/motomundi.svg?v=1.4#i-sm-twitter"
                      />
                    </svg>
                  </NuxtLink>
                </li>
                <li>
                  <NuxtLink
                    to="https://www.youtube.com/MotoMundiTv"
                    target="_blank"
                    rel="noopener"
                    class="sm-yt"
                  >
                    <svg
                      width="17"
                      height="11"
                      xmlns="http://www.w3.org/2000/svg"
                      class="icon sprite-icons"
                    >
                      <title>YouTube</title>
                      <use
                        href="/content/svg/motomundi.svg?v=1.4#i-sm-youtube"
                        xlink:href="/content/svg/motomundi.svg?v=1.4#i-sm-youtube"
                      />
                    </svg>
                  </NuxtLink>
                </li>
                <li>
                  <NuxtLink
                    to="https://www.instagram.com/motomundi/"
                    target="_blank"
                    rel="noopener"
                    class="sm-ig"
                  >
                    <svg
                      width="17"
                      height="17"
                      xmlns="http://www.w3.org/2000/svg"
                      class="icon sprite-icons"
                    >
                      <title>Instagram</title>
                      <use
                        href="/content/svg/motomundi.svg?v=1.4#i-sm-instagram"
                        xlink:href="/content/svg/motomundi.svg?v=1.4#i-sm-instagram"
                      />
                    </svg>
                  </NuxtLink>
                </li>
                <li>
                  <NuxtLink
                    to="https://www.tiktok.com/@motomundicl?"
                    target="_blank"
                    rel="noopener"
                    class="sm-tt"
                  >
                    <svg
                      width="15"
                      height="17"
                      xmlns="http://www.w3.org/2000/svg"
                      class="icon sprite-icons"
                    >
                      <title>TikTok</title>
                      <use
                        href="/content/svg/motomundi.svg?v=1.4#i-sm-tiktok"
                        xlink:href="/content/svg/motomundi.svg?v=1.4#i-sm-tiktok"
                      />
                    </svg>
                  </NuxtLink>
                </li>
                <li>
                  <NuxtLink
                    to="/newsletter.html"
                    rel="nofollow"
                    class="sm-nl mtc-link"
                  >
                    <svg
                      width="16"
                      height="13"
                      xmlns="http://www.w3.org/2000/svg"
                      class="icon sprite-line-icons"
                    >
                      <title>Newsletter</title>
                      <use
                        href="/content/svg/motomundi.svg?v=1.4#i-sm-newsletter"
                        xlink:href="/content/svg/motomundi.svg?v=1.4#i-sm-newsletter"
                      />
                    </svg>
                    Newsletter
                  </NuxtLink>
                </li>
              </ul>
            </nav>
            <div class="footer-lang__block">
              <span class="h3">Idioma</span>
              <div class="footer-lang__block-content">
                <svg
                  width="17"
                  height="17"
                  xmlns="http://www.w3.org/2000/svg"
                  class="lang-icon icon sprite-line-icons"
                  style="top: 4px; position:relative;"
                >
                  <use
                    href="/content/svg/motomundi.svg?v=1.4#i-icon-globe"
                    xlink:href="/content/svg/motomundi.svg?v=1.4#i-icon-globe"
                  />
                </svg>
                <select class="lang-selector">
                  <option
                    selected="selected"
                    value="es"
                  >
                    Español
                  </option>
                </select>
                <svg
                  width="10"
                  height="5"
                  xmlns="http://www.w3.org/2000/svg"
                  class="chevron icon sprite-icons"
                >
                  <use
                    href="/content/svg/motomundi.svg?v=1.4#i-select-arrow"
                    xlink:href="/content/svg/motomundi.svg?v=1.4#i-select-arrow"
                  />
                </svg>
              </div>
            </div>
          </aside>
          <FooterNav />
        </div>
        <aside class="col s12 l12 footer-secondary">
          <div class="footer-secondary__block">
            <ul class="legal-menu">
              <li>
                <NuxtLink
                  to="/informacion/terminos-y-condiciones"
                  rel="nofollow"
                  class="mtc-link"
                >
                  Términos y condiciones
                </NuxtLink>
              </li>
              <li>
                <NuxtLink
                  to="/informacion/terminos-y-condiciones?open=privacy-policy"
                  rel="nofollow"
                  class="mtc-link"
                >
                  Política de privacidad
                </NuxtLink>
              </li>
              <li>
                <NuxtLink
                  to="/informacion/terminos-y-condiciones?open=cookies-policy"
                  rel="nofollow"
                  class="mtc-link"
                >
                  Política de cookies
                </NuxtLink>
              </li>
            </ul>
            <div class="change-locale-desktop-container show-on-medium-and-up">
              <ul class="lang-currency">
                <li>
                  <svg
                    height="11"
                    width="11"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g
                      fill="none"
                      fill-rule="evenodd"
                      stroke="#000"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width=".72"
                    >
                      <path d="M8.682 2.318a4.5 4.5 0 11-6.364 6.364 4.5 4.5 0 016.364-6.364M1 5.5h9" />
                      <path d="M5.5 1h0a6.885 6.885 0 011.8 4.5A6.885 6.885 0 015.5 10h0a6.885 6.885 0 01-1.8-4.5A6.885 6.885 0 015.5 1z" />
                    </g>
                  </svg>
                  <strong>Chile</strong>
                  <svg
                    height="11"
                    width="9"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g
                      fill="none"
                      fill-rule="evenodd"
                      stroke="#000"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width=".8"
                    >
                      <path d="M.45 6.85s.45-.45 1.8-.45 2.25.9 3.6.9 1.8-.45 1.8-.45v-5.4s-.45.45-1.8.45S3.6 1 2.25 1s-1.8.45-1.8.45zM.45 10V6.85" />
                    </g>
                  </svg>
                  <strong>Español</strong>
                  <svg
                    height="11"
                    width="11"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g
                      fill="none"
                      fill-rule="evenodd"
                      stroke="#000"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width=".8"
                    >
                      <path d="M10.032 8.682a4.5 4.5 0 110-6.364M1 4.6h7.65M1 6.4h7.65" />
                    </g>
                  </svg>
                  <strong>Peso chileno</strong>
                </li>
              </ul>
            </div>
            <p>Copyright © 2024 Motomundi SPA · Todos los derechos reservados</p>
          </div>
          <div class="footer-secondary__block">
            <span class="cc-visa"><svg
              width="31"
              height="11"
              xmlns="http://www.w3.org/2000/svg"
              class="icon sprite-icons"
            ><title>VISA</title><use
              href="/content/svg/motomundi.svg?v=1.4#i-cc-visa"
              xlink:href="/content/svg/motomundi.svg?v=1.4#i-cc-visa"
            /></svg></span>
            <span class="cc-mastercard"><svg
              width="33"
              height="20"
              xmlns="http://www.w3.org/2000/svg"
              class="icon sprite-icons"
            ><title>MASTERCARD</title><use
              href="/content/svg/motomundi.svg?v=1.4#i-cc-mastercard"
              xlink:href="/content/svg/motomundi.svg?v=1.4#i-cc-mastercard"
            /></svg></span>
            <span class="cc-maestro"><svg
              width="34"
              height="21"
              xmlns="http://www.w3.org/2000/svg"
              class="icon sprite-icons"
            ><title>MAESTRO</title><use
              href="/content/svg/motomundi.svg?v=1.4#i-cc-maestro"
              xlink:href="/content/svg/motomundi.svg?v=1.4#i-cc-maestro"
            /></svg></span>
            <span class="cc-amex"><svg
              width="35"
              height="14"
              xmlns="http://www.w3.org/2000/svg"
              class="icon sprite-icons"
            ><title>American Express</title><use
              href="/content/svg/motomundi.svg?v=1.4#i-cc-amex"
              xlink:href="/content/svg/motomundi.svg?v=1.4#i-cc-amex"
            /></svg></span>
            <span class="cc-paypal"><svg
              width="32"
              height="9"
              xmlns="http://www.w3.org/2000/svg"
              class="icon sprite-icons"
            ><title>PayPal</title><use
              href="/content/svg/motomundi.svg?v=1.4#i-cc-paypal"
              xlink:href="/content/svg/motomundi.svg?v=1.4#i-cc-paypal"
            /></svg></span>
            <span class="cc-apple-pay"><svg
              width="31"
              height="12"
              xmlns="http://www.w3.org/2000/svg"
              class="icon sprite-icons"
            ><title>Apple Pay</title><use
              href="/content/svg/motomundi.svg?v=1.4#i-cc-apple-pay"
              xlink:href="/content/svg/motomundi.svg?v=1.4#i-cc-apple-pay"
            /></svg></span>
            <span class="cc-google-pay"><svg
              width="31"
              height="12"
              xmlns="http://www.w3.org/2000/svg"
              class="icon sprite-icons"
            ><title>Google Pay</title><use
              href="/content/svg/motomundi.svg?v=1.4#i-cc-google-pay"
              xlink:href="/content/svg/motomundi.svg?v=1.4#i-cc-google-pay"
            /></svg></span>
            <span class="cc-transfer"><svg
              width="14"
              height="13"
              xmlns="http://www.w3.org/2000/svg"
              class="icon sprite-line-icons"
            ><use
              href="/content/svg/motomundi.svg?v=1.4#i-cc-transfer"
              xlink:href="/content/svg/motomundi.svg?v=1.4#i-cc-transfer"
            /></svg><span>Transferencia<br> bancaria</span></span>
          </div>
        </aside>

        <aside
          class="col s12 l12"
          style="text-align: right;"
        >
          <NuxtLink
            to="https://www.ailoo.cl"
            target="_blank"
            style="color: unset;"
          >
            <div class="footer-secondary__block">
              <img
                src="https://www.ailoo.cl/Images/logo.png"
                style="width: 100px;"
              >
            </div>
            <span style="font-size: 12px;">Empresa empoderada con Ailoo</span>
          </NuxtLink>
        </aside>
      </div>
    </div>
  </footer>
</template>

<script setup lang="ts">
import FooterNav from "@/views/pages/navigation/footer-nav.vue"
</script>

<style scoped>
.block-container.seo-footer .container {
  border-bottom: 1px solid #5d5959;
  border-top: 1px solid #5d5959;
  padding: 40px 0;
  width: 93%;
}

.container {
  margin: 0 auto;
  max-width: 1280px;
  width: 90%;
}

.footer-nav {
  grid-column-gap: 20px;
  grid-row-gap: 30px;
  -webkit-column-gap: 20px;
  -moz-column-gap: 20px;
  column-gap: 20px;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
  row-gap: 30px;
}


.footer-nav {
  display: flex;
  flex: 0 0 60%;
  justify-content: space-between;
  margin-top: 20px;
}

.block-container.seo-footer .container li > a {
  padding: 0;
  padding-bottom: 4px;
}

.block-container.seo-footer .footer-nav .mtc-link {
  color: #a3a3a3;
}

.footer-nav__block .footer-nav__menu {
  margin-top: 15px;
}

.footer-nav span.h3 {
  display: block;
  font-size: 13px;
  font-weight: 700;
  margin: 0 0 10px;
  text-transform: uppercase;
}

.seo-footer, .footer {
  background-color: #222222;
  color: #a3a3a3;
  border-radius: unset;
}

.seo-footer a {
  color: #a3a3a3;
}

.footer-description {
  flex: 0 0 35%;
}

.footer-description p {
  font-size: 13px;
  line-height: 18px;
  margin: 15px 0;
}

footer span.h3 {
  display: block;
  font-size: 14px;
  font-weight: 700;
  line-height: 23px;
  margin: 0 0 10px;
  text-transform: uppercase;
}

.footer-description {
  flex: 0 0 35%;
}

footer ul {
  list-style-type: none;
  margin: 0 auto;
  padding: 0;
}

footer.footer .mtc-link {
  color: #a3a3a3;
}

.motomundi-logo {
  align-items: center;
  display: flex;
}

.footer-description nav ul li {
  margin-right: 3px;
}

.footer-description nav ul {
  display: flex;
}

footer.footer nav li > a {
  padding: 0;
}

.footer-description nav ul .mtc-link, .footer-description nav ul a, .footer-description nav ul span {
  align-items: center;
  display: flex;
  height: 30px;
  justify-content: center;
  line-height: 30px;
  text-align: center;
  width: 30px;
}

.footer-description nav ul .mtc-link.sm-blog, .footer-description nav ul a.sm-blog, .footer-description nav ul span.sm-blog {
  background-color: #d6001c;
}

.footer-description nav ul .mtc-link.sm-fb, .footer-description nav ul a.sm-fb, .footer-description nav ul span.sm-fb {
  background-color: #3b5997;
}

.footer-description nav ul .mtc-link.sm-tw, .footer-description nav ul a.sm-tw, .footer-description nav ul span.sm-tw {
  background-color: #1ea0f3;
}

.footer-description nav ul .mtc-link.sm-yt, .footer-description nav ul a.sm-yt, .footer-description nav ul span.sm-yt {
  background-color: #e40303;
}

.footer-description nav ul .mtc-link.sm-ig, .footer-description nav ul a.sm-ig, .footer-description nav ul span.sm-ig {
  background: linear-gradient(45deg, #f09433, #e6683c 25%, #dc2743 50%, #cc2366 75%, #bc1888);
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#f09433", endColorstr="#bc1888", GradientType=1);
}

.footer-description nav ul .mtc-link.sm-tt, .footer-description nav ul a.sm-tt, .footer-description nav ul span.sm-tt {
  background-color: #000;
}

.footer-description nav ul .mtc-link, .footer-description nav ul a, .footer-description nav ul span {
  align-items: center;
  display: flex;
  height: 30px;
  justify-content: center;
  line-height: 30px;
  text-align: center;
  width: 30px;
}

@media (max-width: 1399px) {
  li .mtc-link, li > a {
    font-size: 12px;
    letter-spacing: .5px;
    padding: 6px 10px;
  }
}

.footer-description nav ul .mtc-link.sm-nl svg, .footer-description nav ul a.sm-nl svg, .footer-description nav ul span.sm-nl svg {
  margin-right: 3px;
}

.footer-description nav ul .mtc-link.sm-nl svg use, .footer-description nav ul a.sm-nl svg use, .footer-description nav ul span.sm-nl svg use {
  fill: none;
  stroke: #fff;
  stroke-width: 1;
}

.footer-lang__block {
  margin-top: 30px;
}

.footer-lang__block select.lang-selector {
  background: transparent;
  border: none;
  cursor: pointer;
  font-size: 13px;
  font-weight: 400;
  margin: 0 0 0 -15px;
  padding: 0 25px;
  position: relative;
  text-transform: none;
  color: #a3a3a3;
}

.footer-nav {
  grid-column-gap: 20px;
  grid-row-gap: 30px;
  -webkit-column-gap: 20px;
  -moz-column-gap: 20px;
  column-gap: 20px;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
  row-gap: 30px;
}

.lang-currency {
  position: relative;
}

.lang-currency > li {
  display: inline-block;
  padding-bottom: 2px;
}

.footer-description {
  flex: 0 0 35%;
}


footer {
  background-color: #f5f5f5;
  background-color: #222222;
  color: #a3a3a3;
  padding: 50px 10px;
}

.footer-container {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}

.footer-secondary__block:first-child li {
  display: inline;
  margin-right: 8px;
}

.footer-lang__block svg use {
  stroke: #a3a3a3;
}

.footer-secondary__block:last-child > span svg {
  display: inline-block;
  margin-right: 3px;
}

.footer-description nav ul .mtc-link.sm-nl, .footer-description nav ul a.sm-nl, .footer-description nav ul span.sm-nl {
  background-color: #e40303;
  color: #fff;
  font-size: 9px;
  padding: 0 8px;
  text-transform: uppercase;
  width: auto;
}

@media only screen and (min-width: 993px) {
  .row .col.l12 {
    width: 100%;
  }
}


@media only screen and (min-width: 993px) {
  .row .col.l11, .row .col.l12 {
    left: auto;
    margin-left: auto;
    right: auto;
  }
}

.footer-secondary {
  border-top: 1px solid #d8d8d8;
  display: flex;
  justify-content: space-between;
  margin-top: 20px !important;
}

.footer-secondary__block {
  padding-top: 30px !important;
}

.footer-secondary__block:first-child {
  flex: 0 0 38%;
}

.legal-menu {
  font-size: 11px;
  line-height: 1.2;
}

.footer-secondary__block:first-child li {
  display: inline;
  margin-right: 8px;
}

footer.footer .mtc-link {
  color: #a3a3a3;
}

.legal-menu li a {
  font-size: 11px;
  line-height: 1.2;
  padding: 0;
  text-transform: none;
}

footer ul {
  list-style-type: none;
  margin: 0 auto;
  padding: 0;
}

li .mtc-link, li > a {
  color: #000;
  display: inline-block;
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 0;
  /* line-height: 1.05em; */
  padding: 6px 18px;
  text-transform: uppercase;
}

.footer-secondary__block:first-child li {
  display: inline;
  margin-right: 8px;
}

div.change-locale-desktop-container {
  cursor: default;
  padding-top: 30px !important;
}

.lang-currency {
  position: relative;
}

.lang-currency > li svg {
  vertical-align: -2px;
}

.lang-currency > li strong {
  background-color: transparent;
  background-image: none;
  border: 0;
  font-size: 9px;
  line-height: 1.2;
  margin-bottom: 3px;
  margin-right: 8px;
  padding: 0;
  text-transform: uppercase;
}

.footer-secondary__block:first-child p {
  color: #484848;
  font-size: 11px;
  line-height: 13px;
  margin: 0;
}

.legal-menu li a:hover {
  color: #d6001c;
}

.lang-currency svg g {
  stroke: white;
  fill: #a3a3a3;
}

.footer-secondary__block:last-child {
  display: flex;
  flex: 0 0 60%;
  flex-wrap: wrap;
  justify-content: flex-end;
}

.footer-secondary__block:last-child > span {
  align-items: center;
  background-color: red;
  border-radius: 3px;
  display: flex;
  font-weight: 500;
  height: 30px;
  justify-content: center;
  line-height: 1;
  margin: 1px 3px 1px 0;
  width: 50px;
}

.footer-nav .mtc-link {
  color: #000;
  font-size: 12px;
  line-height: unset;
  text-transform: unset;
  font-weight: normal;
}


.footer-secondary__block:last-child > span.cc-cod use, .footer-secondary__block:last-child > span.cc-transfer use {
  stroke: #fff;
  stroke-width: 1;
}

.footer-secondary__block:last-child > span.cc-cod, .footer-secondary__block:last-child > span.cc-transfer {
  color: #fff;
  font-size: 8px;
  padding: 0 8px;
  text-transform: uppercase;
  width: auto;
}

.footer-secondary__block:last-child > span.cc-cod svg, .footer-secondary__block:last-child > span.cc-transfer svg {
  margin-right: 5px;
}

.footer-secondary__block:last-child > span.cc-cod use, .footer-secondary__block:last-child > span.cc-transfer use {
  stroke: #fff;
  stroke-width: 1;
}

.footer-secondary__block:last-child > span.cc-cod svg, .footer-secondary__block:last-child > span.cc-transfer svg {
  margin-right: 5px;
}

.footer-secondary__block:last-child > span.cc-transfer {
  background-color: #d6001c;
}

.footer-secondary__block:last-child > span.cc-amex {
  background-color: #0072ce;
}

.footer-secondary__block:last-child > span.cc-paypal {
  background-color: #00457c;
}

.footer-secondary__block:last-child > span.cc-apple-pay, .footer-secondary__block:last-child > span.cc-google-pay {
  background-color: #000;
}

.footer-secondary__block:last-child > span.cc-apple-pay, .footer-secondary__block:last-child > span.cc-google-pay {
  background-color: #000;
}

.footer-secondary__block:last-child > span.cc-visa {
  background-color: #26337a;
}

.footer-secondary__block:last-child > span {
  align-items: center;
  background-color: red;
  border-radius: 3px;
  display: flex;
  font-weight: 500;
  height: 30px;
  justify-content: center;
  line-height: 1;
  margin: 1px 3px 1px 0;
  width: 50px;
}

.footer-secondary__block:last-child > span.cc-maestro, .footer-secondary__block:last-child > span.cc-mastercard {
  background-color: #006;
}

@media (max-width: 1399px) {
  li .mtc-link, li > a {
    font-size: 11px;
    letter-spacing: .5px;
    padding: 6px 10px;
  }
}
</style>
